import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererActions from "@/components/optimization/upload-file/cell-renderer-vehicle/CellRendererActions.vue";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const uploadVehicleList = {
	name: "uploadVehicleList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showPopup: false,
					showMaximizeBtn: false,
					showActions: false,
				};
			},
		},
		maximize: {
			type: Boolean,
			default: true,
		},
		isHeightMedium: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererActions,
	},
	data() {
		return {
			currentPageLocal: 1,
			quantityElementPage: 3,
			gridApi: null,
			gridOptions: {},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererActions,
			},
		};
	},
	computed: {
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let columns = [
				{
					headerName: "Path",
					field: "bucket_path",
					width: 650,
					checkboxSelection: true,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: true,
					cellRendererFramework: null,
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		usersData() {
			return this.$store.state.vehicle.uploadFileList === undefined ||
				this.$store.state.vehicle.uploadFileList === "" ||
				this.$store.state.vehicle.uploadFileList === null
				? []
				: this.$store.state.vehicle.uploadFileList;
		},
		getCheckedUploadFile() {
			return this.$store.state.vehicle.checkedUploadFiles === undefined ||
				this.$store.state.vehicle.checkedUploadFiles === "" ||
				this.$store.state.vehicle.checkedUploadFiles === null
				? []
				: this.$store.state.vehicle.checkedUploadFiles;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
	},
	methods: {
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("vehicle/ADD_CHECKED_UPLOAD_FILE_VEHICLE", event.data);
			} else {
				this.$store.commit("vehicle/REMOVE_CHECKED_UPLOAD_FILE_VEHICLE", event.data);
			}
			if (this.getCheckedUploadFile.length > 2) {
				this.gridApi.getRowNode(event.rowIndex).setSelected(false);
				this.$vs.notify({
					color: "success",
					title: this.$t("UploadFiles.SelectFile"),
					text: this.$t("TheMaximumFileSelectionForVehiclesHasBeenReached"),
					time: 5000,
				});
			}
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		this.gridApi.forEachNode((node) => node.setSelected(true));
	},
	created() {
		this.tooltipShowDelay = 500;
	},
};
